import React, { useState } from 'react';
import { Input } from '@scuf/common';
import DayPickerInput from 'react-day-picker/DayPickerInput';
import MomentLocaleUtils from 'react-day-picker/moment';
import {
  checkIsNullOrUndefined,
  formatDate
} from '../../utils/Functions/shared-utility';
import './date-selector.scss';
import TranslationUtility from '../../utils/translations/TranslationsUtility';
import InfoTooltip from '../InfoTooltip/InfoTooltip';
import { useTranslation } from '@scuf/localization';
import { HOCLocalization } from '../../utils/HOC/HOCLocalization';
interface IDateSelector {
  label?: string;
  value: Date | string;
  maxAllowedDays?: number;
  dateFormat: string;
  /**
   * Called when a valid date has been selected
   */
  onChange?: (date: Date) => void;
  /**
   * Called when particular month need to disable
   */
  endDate?: Date;
  hideToday?: boolean;
}

const DateSelector = (props: IDateSelector) => {
  const [error, setError] = useState(false);
  const maxAllowedDays = props.maxAllowedDays ? props.maxAllowedDays : 30;
  const [t, lng] = useTranslation();
  const getDefaultDate = () => {
    const convertedDate: Date = new Date();
    convertedDate.setDate(new Date().getDate() - maxAllowedDays);
    convertedDate.setHours(0, 0, 0, 0);
    return convertedDate;
  };

  const datePickerOnChange = (date: Date) => {
    date.setHours(0);
    const dateResult = date < getDefaultDate() ? true : false;
    if (dateResult) {
      setError(true);
    } else {
      setError(false);
      if (props.onChange) {
        props.onChange(date);
      }
    }
  };

  return (
    <div className="date-selector">
      <div className="date-select-container">
        <span>{props.label || t('dateFrom')}</span>
        <DayPickerInput
          component={(dayPickerCompProps: any) => (
            <Input
              {...dayPickerCompProps}
              placeholder={props.dateFormat}
              icon="calendar"
            />
          )}
          style={error ? { border: '2px solid #F15A4F' } : {}}
          key={'header-date-picker-' + props.dateFormat}
          format={props.dateFormat}
          formatDate={formatDate}
          placeholder={props.dateFormat}
          inputProps={{ readOnly: true, ref: null }}
          dayPickerProps={{
            selectedDays: new Date(props.value),
            locale: TranslationUtility.getLocale(lng),
            localeUtils: MomentLocaleUtils,
            todayButton: props.hideToday ? '' : t('showToday'),
            modifiers: {
              disabled: [
                {
                  after: props.endDate ? props.endDate : new Date(),
                  before: new Date(
                    new Date().setDate(new Date().getDate() - maxAllowedDays)
                  )
                }
              ]
            }
          }}
          value={props.value}
          onDayChange={datePickerOnChange}
        />
      </div>
      <InfoTooltip
        content={
          error
            ? t('outOfRange')
            : t('selectUpToDays', { maxDays: maxAllowedDays })
        }
        position="bottom right"
        color={error ? '#BE271C' : ''}
      />
    </div>
  );
};
export default HOCLocalization(DateSelector);
